// 站点地图
<template>
  <div class="siteMap">
    <div class="title">站点地图</div>
    <div class="content">
      <div
        class="type"
        v-for="(item, index) in map"
        :key="`type-item${index + 1}`"
      >
        <div class="type-name">{{ item.name }}</div>
        <div class="menu-list">
          <div
            class="menu-item"
            v-for="(it, i) in item.children"
            :key="`menu-item${i + 1}`"
            @click="goPath(it.path)"
          >
            {{ it.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "siteMap",
  data() {
    return {
      map: [
        {
          name: "产品服务",
          children: [
            { name: "产品架构", path: "/productArchitecture" },
            { name: "认知智能算法平台", path: "/productCognitive" },
            { name: "工业级智能体", path: "/productManufacture" },
            { name: "运营决策智能体", path: "/operationDecision" }
          ]
        },
        {
          name: "技术生态",
          children: [
            { name: "核心技术", path: "/ecologicalCoreTechnology" },
            { name: "世界人工智能大会", path: "/ecologicalWaic" },
            { name: "研究院", path: "/ecologicalInstitute" }
          ]
        },
        {
          name: "关于华院",
          children: [
            // { name: "核心能力", path: "/about?tab=0" },
            { name: "华院团队", path: "/about?tab=0" },
            { name: "社会责任", path: "/about?tab=1" },
            { name: "荣誉资质", path: "/about?tab=2" },
            { name: "联系我们", path: "/about?tab=3" }
          ]
        },
        {
          name: "加入我们",
          children: [{ name: "查看", path: "/addUs" }]
        }
      ]
    };
  },
  methods: {
    goPath(path) {
      this.$router.push(path);
    }
  }
};
</script>
<style lang="less" scoped>
.siteMap {
  width: 100%;
  padding: 96px 0px;
  .title {
    width: calc(100% - 64px);
    height: 174px;
    background: url("../../../static/img/other/legalnotice_bg.png") no-repeat 0
      0 / 100%;
    overflow: hidden;
    font-size: 44px;
    color: #08204d;
    line-height: 174px;
    padding-left: 64px;
  }
  .content {
    padding: 40px 64px;
    display: flex;
    flex-wrap: wrap;
    .type {
      width: 50%;
      margin-bottom: 20px;
      .type-name {
        font-size: 32px;
        color: #08204d;
        line-height: 44px;
      }
      .menu-list {
        margin-top: 24px;
        .menu-item {
          font-size: 24px;
          font-weight: 400;
          color: #08204d;
          line-height: 40px;
          margin-bottom: 28px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/otherfunction/siteMap.vue